import BasicEditor from './BasicEditor';
export default BasicEditor;
